import { createRouter, createWebHistory } from 'vue-router';

const routes = [
	{
		path: '/login',
		name: 'Login',
		meta: {
			title: '登录',
		},
		component: () =>
			import(/* webpackChunkName: "login" */ '../views/login'),
	},
	{
		path: '/register',
		name: 'Register',
		meta: {
			title: '注册',
		},
		component: () =>
			import(/* webpackChunkName: "register" */ '../views/register'),
	},
	{
		path: '/error', // 错误
		name: 'Error',
		meta: {
			title: '出错了',
		},
		component: () =>
			import(/* webpackChunkName: "error" */ '../views/error'),
	},
	{
		path: '/',
		name: 'Layout',
		redirect: '/home',
		component: () => import(/* webpackChunkName: "layout" */ '../layout'),
		children: [
			{
				path: 'home',
				meta: {
					title: '首页',
				},
				name: 'Layout',
				component: () =>
					import(/* webpackChunkName: "home" */ '../views/home'),
			},
			{
				path: 'user',
				name: 'User',
				meta: {
					title: '个人中心',
				},
				component: () =>
					import(/* webpackChunkName: "user" */ '../views/user'),
			},
			{
				path: 'playlist', // 媒体.播放
				name: 'Playlist',
				meta: {
					title: '媒体.播放',
				},
				component: () =>
					import(
						/* webpackChunkName: "playlist" */ '../views/playlist'
					),
			},
		],
	},
	{
		path: '/userinfo',
		name: 'UserInfo',
		meta: {
			title: '用户信息',
		},
		component: () =>
			import(
				/* webpackChunkName: "userinfo" */ '../views/user/userinfo.vue'
			),
	},
	{
		path: '/feedback', // 用户意见反馈
		name: 'Feedback',
		meta: {
			title: '意见反馈',
		},
		component: () =>
			import(
				/* webpackChunkName: "feedback" */ '../views/user/feedback.vue'
			),
	},
	{
		path: '/wxbind', // 安全与绑定
		name: 'Wxbind',
		meta: {
			title: '安全与绑定',
		},
		component: () =>
			import(/* webpackChunkName: "wxbind" */ '../views/user/wxbind.vue'),
	},
	{
		path: '/activation', // 激活设备
		name: 'Activation',
		meta: {
			title: '激活设备',
		},
		component: () =>
			import(
				/* webpackChunkName: "activation" */ '../views/user/activation.vue'
			),
	},
	{
		path: '/setting', // 参数与设置
		name: 'Setting',
		meta: {
			title: '设置',
		},
		component: () =>
			import(/* webpackChunkName: "setting" */ '../views/setting'),
	},
	{
		path: '/icon', // 更换设备头像
		name: 'Icon',
		meta: {
			title: '设备头像',
		},
		component: () => import(/* webpackChunkName: "icon" */ '../views/icon'),
	},
	{
		path: '/lotteryIntroduction', // 抽奖游戏介绍
		name: 'LotteryIntroduction',
		meta: {
			title: '抽奖游戏介绍',
		},
		component: () =>
			import(
				/* webpackChunkName: "lotteryIntroduction" */ '../views/lotteryIntroduction'
			),
	},
	{
		path: '/upload', // 媒体上传
		name: 'UploadMedia',
		meta: {
			title: '媒体上传',
		},
		component: () =>
			import(/* webpackChunkName: "uploadMedia" */ '../views/upload'),
	},
	{
		path: '/subtitle', // 制作字幕
		name: 'Subtitle',
		meta: {
			title: '滚动字幕制作',
		},
		component: () =>
			import(/* webpackChunkName: "subtitle" */ '../views/subtitle'),
	},
	// {
	// 	path: '/template', // 选择模版
	// 	name: 'Template',
	// 	component: () =>
	// 		import(
	// 			/* webpackChunkName: "template" */ '../views/subtitle/template.vue'
	// 		),
	// },
	{
		path: '/terms', // 多动屏客户端服务条款
		name: 'Terms',
		meta: {
			title: '服务条款',
		},
		component: () =>
			import(/* webpackChunkName: "terms" */ '../views/terms'),
	},
	{
		path: '/tts', // 配音广播
		name: 'Tts',
		meta: {
			title: '配音广播',
		},
		component: () => import(/* webpackChunkName: "tts" */ '../views/tts'),
	},
	{
		path: '/exchange', // 中奖-兑奖
		name: 'Exchange',
		meta: {
			title: '兑奖',
		},
		component: () =>
			import(/* webpackChunkName: "exchange" */ '../views/exchange'),
	},
	{
		path: '/doodling', // 小黑板
		name: 'Doodling',
		meta: {
			title: '小黑板',
		},
		component: () =>
			import(/* webpackChunkName: "doodling" */ '../views/doodling'),
	},
	{
		path: '/aboutus', // 关于我们
		name: 'AboutUs',
		meta: {
			title: '关于我们',
		},
		component: () =>
			import(/* webpackChunkName: "aboutus" */ '../views/aboutus'),
	},
	// {
	// 	path: '/touchable', // 触摸功能
	// 	name: 'Touchable',
	// 	component: () =>
	// 		import(
	// 			/* webpackChunkName: "touchable" */ '../views/setting/touchable.vue'
	// 		),
	// },
	{
		path: '/screen', // 远程截屏
		name: 'Screen',
		meta: {
			title: '设备截屏',
		},
		component: () =>
			import(
				/* webpackChunkName: "screen" */ '../views/setting/screen.vue'
			),
	},
	{
		path: '/admins', // 设备管理员
		name: 'Admins',
		meta: {
			title: '设备管理员',
		},
		component: () =>
			import(
				/* webpackChunkName: "admins" */ '../views/setting/admins.vue'
			),
	},
	{
		path: '/windows', // 分屏功能
		name: 'Windows',
		meta: {
			title: '分屏功能',
		},
		component: () =>
			import(
				/* webpackChunkName: "windows" */ '../views/setting/windows.vue'
			),
	},
	{
		path: '/devfee', // 软件授权
		name: 'Devfee',
		meta: {
			title: '服务费支付',
		},
		component: () =>
			import(/* webpackChunkName: "devfee" */ '../views/devfee'),
	},
	{
		path: '/reset', // 软件授权-重置设备
		name: 'DevfeeReset',
		meta: {
			title: '重置设备',
		},
		component: () =>
			import(/* webpackChunkName: "reset" */ '../views/devfee/reset'),
	},
	{
		path: '/pay', // 软件授权-微信支付
		name: 'DevfeePay',
		meta: {
			title: '支付',
		},
		component: () =>
			import(/* webpackChunkName: "reset" */ '../views/devfee/pay'),
	},
	{
		path: '/bill', // 历史账单
		name: 'Bill',
		meta: {
			title: '历史账单',
		},
		component: () => import(/* webpackChunkName: "bill" */ '../views/bill'),
	},
	{
		path: '/invoice', // 索要发票
		name: 'Invoice',
		meta: {
			title: '索要发票',
		},
		component: () =>
			import(/* webpackChunkName: "invoice" */ '../views/invoice'),
	},
	{
		path: '/invoices', // 索要发票
		name: 'Invoices',
		meta: {
			title: '发票记录',
		},
		component: () =>
			import(
				/* webpackChunkName: "invoices" */ '../views/invoice/invoices'
			),
	},
	{
		path: '/appUpdate', // 版本与升级
		name: 'AppUpdate',
		meta: {
			title: '版本与升级',
		},
		component: () =>
			import(/* webpackChunkName: "appUpdate" */ '../views/appUpdate'),
	},
	{
		path: '/howtouse', // 客户端使用问答
		name: 'Howtouse',
		meta: {
			title: '使用说明',
		},
		component: () =>
			import(/* webpackChunkName: "howtouse" */ '../views/howtouse'),
	},
	{
		path: '/raffle', // 抽奖游戏制作
		name: 'Raffle',
		meta: {
			title: '游戏制作',
		},
		component: () =>
			import(/* webpackChunkName: "raffle" */ '../views/raffle'),
	},
	{
		path: '/deviceExamine', // 设备检测
		name: 'DeviceExamine',
		meta: {
			title: '设备检测',
		},
		component: () =>
			import(
				/* webpackChunkName: "deviceExamine" */ '../views/deviceExamine'
			),
	},
];

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
});

export default router;
